
import CarouselControls from './CarouselControls.vue'
import CarouselIndicators from './CarouselIndicators.vue'
import ProductCardCarousel from '~/components/product-card/ProductCardCarousel.vue'

export default {
  name: 'ProductListCarousel',
  components: {
    ProductCardCarousel,
    CarouselControls,
    CarouselIndicators,
  },
  props: {
    products: {
      type: Array,
      required: true,
    },
    queryID: {
      type: String,
      required: false,
      default: '',
    },
    controls: {
      type: Boolean,
      default: false,
      required: false,
    },
    indicators: {
      type: Boolean,
      default: false,
      required: false,
    },
    interval: {
      type: Number,
      default: 5000,
      required: false,
    },
  },
  data: () => ({
    currentSlide: 0,
    slideInterval: null,
    direction: 'left',
    annimateToDisappearIndex: -1,
    isFirstTimeLoad: true,
  }),
  computed: {
    showControls () {
      return this.controls && this.products.length > 1
    },
    showIndicators () {
      return this.indicators && this.products.length > 1
    },
  },
  mounted () {
    // this.startSlideTimer()
  },
  beforeUnmount () {
    this.stopSlideTimer()
  },
  methods: {
    setCurrentSlide (index) {
      this.currentSlide = index
    },
    prev (step = -1) {
      if (this.products.length <= 1) { return }
      this.isFirstTimeLoad = false
      const index = this.currentSlide > 0 ? this.currentSlide + step : this.products.length - 1
      this.annimateToDisappearIndex = this.currentSlide
      this.setCurrentSlide(index)
      this.direction = 'right'
      // this.startSlideTimer()
    },
    _next (step = 1) {
      this.isFirstTimeLoad = false
      const index = this.currentSlide < this.products.length - 1 ? this.currentSlide + step : 0
      this.annimateToDisappearIndex = this.currentSlide
      this.setCurrentSlide(index)
      this.direction = 'left'
    },
    next (step = 1) {
      if (this.products.length <= 1) { return }
      this._next(step)
      // this.startSlideTimer()
    },
    startSlideTimer () {
      this.stopSlideTimer()
      this.slideInterval = setInterval(
        () => { this._next() },
        this.interval
      )
    },
    stopSlideTimer () {
      clearInterval(this.slideInterval)
    },
    switchSlide (index) {
      const step = index - this.currentSlide
      if (step > 0) {
        this.next(step)
      } else {
        this.prev(step)
      }
    },
  },
}
